module.exports = __webpack_public_path__ + "static/media/3D_KEYBOARD.8b540bd8.svg";